import { render, staticRenderFns } from "./VivaWalletFailure.vue?vue&type=template&id=369e069b"
import script from "./VivaWalletFailure.vue?vue&type=script&lang=js"
export * from "./VivaWalletFailure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports